/**
 * Keyboard event handler to block non-numeric characters in number inputs.
 * Allows: digits, Backspace, Delete, Tab, Arrow keys, Home, End, Ctrl/Cmd combos.
 * Blocks: e, E, +, -, letters, symbols.
 */
export const blockNonNumeric = (allowDecimal = true) => (e) => {
  const blocked = allowDecimal
    ? ['e', 'E', '+', '-']
    : ['e', 'E', '+', '-', '.'];
  if (blocked.includes(e.key)) {
    e.preventDefault();
  }
};

export const integerOnly = blockNonNumeric(false);
export const decimalOnly = blockNonNumeric(true);
